import React from "react";
import { components } from "react-select";

const PerformerDropdownIndicator = (props: any) => (
  <components.DropdownIndicator {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
      <path d="M1 1L5 5L9 1" stroke="#1E1E1E" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </components.DropdownIndicator>
);

export default PerformerDropdownIndicator;
